import { Button } from '@fox/atoms/src/button/index';
import { Icon } from '@fox/atoms/src/icon/index';
import { getExtension } from '@fox/extensions/src/extension-context';
import { useTheme } from 'styled-components';
import { isGraphColumn, selectableColumn, useAutoDataGridContext } from '../../auto-data-grid/context';
import { FilterOperatorProps } from '../../contracts/FilterOperatorProps';
import { ChecklistPopover } from '../checklist/index';

export function PinPopover<T>() {
	const theme = useTheme();
	const { pinnedColumnsDataIndex, setPinnedColumnsDataIndex, hiddenColumnsDataIndex, allColumns } = useAutoDataGridContext();
	const numPinned = pinnedColumnsDataIndex.length;

	return (
		<div>
			<ChecklistPopover
				options={allColumns
					.filter(a => !hiddenColumnsDataIndex.includes(a.dataIndex) && isGraphColumn(a) && selectableColumn(a))
					.map(a => ({
						id: a.dataIndex,
						title: a.title,
						icon: getExtension<FilterOperatorProps>(`column-operators-${a.filterType}`)?.icon
					}))}
				selected={pinnedColumnsDataIndex}
				title={'Pin'}
				onSelect={savedState => {
					setPinnedColumnsDataIndex(savedState);
				}}
			>
				<Button
					title="Pin column"
					style={{
						backgroundColor: numPinned > 0 ? theme.colors.grey[200] : '',
						borderRadius: '35%/45%',
						minWidth: 'auto'
					}}
					sx={{ '&:hover': { opacity: numPinned > 0 ? '0.8 !important' : 'unset' } }}
				>
					<Icon iconName={'PushPin'} sx={{ width: '20px', height: '20px' }} color="action" />
					{pinnedColumnsDataIndex.length > 0 && (
						<div style={{ marginLeft: '3px', marginRight: '2px' }}>{pinnedColumnsDataIndex.length}</div>
					)}
				</Button>
			</ChecklistPopover>
		</div>
	);
}
